import axios from '@/libs/api.request'
// 导师端简历信息表接口
const cvService = {
  // 基本信息-en
  cvBaseInfoDetailEn (data) {
    return axios.request({
      url: '/ugd/mentee/detail',
      data,
      method: 'POST'
    })
  },
  // 个人信息-en
  cvBaseTeamInfoDetailEn (data) {
    return axios.request({
      url: '/ugd/mentee/team',
      data,
      method: 'POST'
    })
  },
  // 个人信息-en
  cvPersonalInfoDetailEn (data) {
    return axios.request({
      url: '/ugd/mentee/info/basic/en',
      data,
      method: 'POST'
    })
  },
  // 教育背景-en
  cvEducationDetailEn (data) {
    return axios.request({
      url: '/ugd/mentee/info/education/en',
      data,
      method: 'POST'
    })
  },
  // 课程信息-en
  cvCourseDetailEn (data) {
    return axios.request({
      url: '/ugd/mentee/info/course/en',
      data,
      method: 'POST'
    })
  },
  // 标准化考试成绩-en
  cvScoreDetailEn (data) {
    return axios.request({
      url: '/ugd/mentee/info/score/en',
      data,
      method: 'POST'
    })
  },
  // 学分课程信息-en
  cvCreditDetailEn (data) {
    return axios.request({
      url: '/ugd/mentee/info/credit/en',
      data,
      method: 'POST'
    })
  },
  // 奖项-en
  cvAwardsDetailEn (data) {
    return axios.request({
      url: '/ugd/mentee/info/awards/en',
      data,
      method: 'POST'
    })
  },
  // 活动-en
  cvActivityDetailEn (data) {
    return axios.request({
      url: '/ugd/mentee/info/active/en',
      data,
      method: 'POST'
    })
  },
  // 爱好与特长-en
  cvHobbyDetailEn (data) {
    return axios.request({
      url: '/ugd/mentee/info/hobbies/en',
      data,
      method: 'POST'
    })
  }
}

export default cvService
